import script from "./DoctorEntity.vue?vue&type=script&lang=ts&setup=true"
export * from "./DoctorEntity.vue?vue&type=script&lang=ts&setup=true"

import "./DoctorEntity.vue?vue&type=style&index=0&id=21686319&lang=scss"

const __exports__ = script;

export default __exports__